import { createAction } from '@reduxjs/toolkit';

import { eventAddReducerTypes, eventShowReducerTypes, eventSingleShowReducerTypes } from 'types';

export const EVENT_ADD_SAGA = 'EVENT_ADD_SAGA';
export const eventAddSaga = createAction<eventAddReducerTypes.IEventAddForm>(EVENT_ADD_SAGA);

export const EVENT_SHOW_SAGA = 'EVENT_SHOW_SAGA';
export const eventShowSaga = createAction<eventShowReducerTypes.IEventShowForm>(EVENT_SHOW_SAGA);

export const EVENT_SINGLE_SHOW_SAGA = 'EVENT_SINGLE_SHOW_SAGA';
export const eventSingleShowSaga =
    createAction<eventSingleShowReducerTypes.IEventSingleShowForm>(EVENT_SINGLE_SHOW_SAGA);

export const EVENT_DELETE_SAGA = 'EVENT_DELETE_SAGA';
export const eventDeleteSaga = createAction<eventSingleShowReducerTypes.IEventSingleShowForm>(EVENT_DELETE_SAGA);
